import type { OrganizationDefinition, OrganizationId } from "../domain/types/index.js";

export const ORGANIZATIONS = {
  qa: {
    id: "qa", name: "品質保証プロセス",
    text: "各フェーズ開始時に防御+1。",
  },
  schedule: {
    id: "schedule", name: "スケジュール交渉",
    text: "各プロジェクトの工期が1増える。",
  },
  mental: {
    id: "mental", name: "メンタル研修",
    text: "疲労の上限が12になる。",
  },
  "short-focus": {
    id: "short-focus", name: "短期集中",
    text: "毎フェーズの行動+1。各プロジェクトの工期が1減る。",
  },
  "manager-training": {
    id: "manager-training", name: "管理者研修",
    text: "新卒と窓際以外の労働者の進捗が1増える。",
  },
  negotiation: {
    id: "negotiation", name: "交渉術",
    text: "防御が負荷の進捗戻しも軽減する。",
  },
  "small-elite": {
    id: "small-elite", name: "少数精鋭",
    text: "デッキが10枚以下なら、毎フェーズ1枚引き、行動+1。",
  },
  "flat-org": {
    id: "flat-org", name: "フラット組織",
    text: "施策を1枚も使わなければ、手札の労働者の進捗が1増える。",
  },
  "expansion-strategy": {
    id: "expansion-strategy", name: "拡大戦略室",
    text: "所有する新卒が15枚以上なら、毎フェーズ開始時に3枚引く。",
  },
  "investment-committee": {
    id: "investment-committee", name: "投資推進室",
    text: "このPJで投資施策を累計3回使っていれば、毎フェーズの行動+1。",
  },
} as const satisfies Record<string, OrganizationDefinition>;

export const ORG_REWARD_POOL = [
  "qa",
  "schedule",
  "mental",
  "short-focus",
  "manager-training",
  "negotiation",
  "small-elite",
  "flat-org",
  "expansion-strategy",
] as const satisfies readonly OrganizationId[];
